import { gql } from '@apollo/client'

import { EVENT_FRAGMENT } from '../../../common/graphql/fragments'

import { SIMPLE_CHALLENGE_FRAGMENT } from '../fragments'

const DELETE_CHALLENGE_MUTATION = gql`
  mutation deleteChallenge($id: ID!) {
    deleteChallenge(id: $id) {
      results {
        ...SimpleChallengeFragment
      }
      latestEvent {
        ...EventFragment
      }
    }
  }
  ${SIMPLE_CHALLENGE_FRAGMENT}
  ${EVENT_FRAGMENT}
`

export default DELETE_CHALLENGE_MUTATION
